import { Link as DSLink, Heading, Span } from "@icg360/design-system";

import { Stack } from "components/common/stack";
import { AvailableOffers } from "components/offers/available-offers";
import { EnrolledOffers } from "components/offers/enrolled-offers";
import { useEligibleOffers } from "components/offers/hooks";
import { type Policy } from "data/keystone-api-mapping";
import SettingsPolicy from "pages/settings/common/settings-policy";
import { isFloodPolicy, switchPolicy } from "utils";

import styles from "./offers-item.module.scss";

type OffersItemProps = {
  policy: Policy;
};

const OffersItem = ({ policy }: OffersItemProps) => {
  const {
    eligibleOffers: { allOffers, enrolledOffers, unenrolledOffers },
    loading,
  } = useEligibleOffers(policy.insightPolicyId);

  const onViewProperty = () => {
    switchPolicy(policy.insightPolicyId, "/my/property");
  };

  const detailItems = !loading
    ? [
        {
          label: "Policy number:",
          value: (
            <>
              {policy.policyId}{" "}
              {!isFloodPolicy(policy?.carrierGroupId, policy?.policyType) && (
                <DSLink
                  onPress={onViewProperty}
                  className={styles.viewPolicyLinkDS}
                >
                  View property
                </DSLink>
              )}
            </>
          ),
        },
      ]
    : [];

  return (
    <SettingsPolicy
      key={policy.policyId}
      isCommercial={!!policy.isCommercial}
      address={policy.propertyAddress}
      detailItems={detailItems}
      loading={loading}
      policyType={policy.policyType}
    >
      {allOffers.length ? (
        <Stack>
          <AvailableOffers
            unenrolledOffers={unenrolledOffers}
            policy={policy}
            from="/my/settings/property-services"
            heading={
              <Heading size="sm" className={styles.enrolledHeadingDS}>
                Available
              </Heading>
            }
          />
          <EnrolledOffers
            enrolledOffers={enrolledOffers}
            heading={
              <Heading size="sm" className={styles.enrolledHeadingDS}>
                Enrolled
              </Heading>
            }
          />
        </Stack>
      ) : (
        <Span color="quiet">
          This policy is currently not eligible for any of SageSure&apos;s
          property services.
        </Span>
      )}
    </SettingsPolicy>
  );
};

export default OffersItem;
